export default {
  getBillingAddress: state => state.billingAddress
}
